// change to LogsPage if making another css file
import './RegistrationPage.css';
import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';


function RegistrationPage(handleSubmit) {
  return (
    <div>
        <div class="RegistrationBanner">
          DriveWise
        </div>
        {RegistrationPanel(handleSubmit)}
    </div>
  )
}

function RegistrationPanel(props) {
    return (
        <div class="Registration">
            <h1>Register</h1>
            <Form onSubmit={props.handleSubmit}>
            <div id="registration">
                    <label>Device ID
                      <input type="text" placeholder=" Enter the ID on your DriveWise device" size="35"/>
                    </label>
              </div>
              <div id="registration">
                    <label>Email
                      <input type="email" size="40"/>
                    </label>
              </div>
              <div id="registration">
                    <label>Password
                      <input type="password" size="35"/>
                    </label>
              </div>
                <Button variant="secondary" type="submit">
                    Register
                </Button>
            </Form>
            <div>
              <p>Already have an account?</p>
              <Button variant="secondary" className="secondary" onClick={props.toLogin}>Back to Login</Button>
            </div>
        </div>
    );
    // then somehow we do something with the entered data and send it to a login service
}

export default RegistrationPage;